module.exports = __webpack_public_path__ + "img/14ry_download.a496f4dc.png";